import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from './modelData';
import { RootStoreType } from '../rootReducer';

const statesSlice = createSlice({
    name: 'modelDataReducer',
    initialState: initialState.modelData,
    reducers: {
        setIsShowModelDataModal: (state, action: PayloadAction<boolean>) => {
            state.isShowModal = action.payload;
        },
        setModelData: (state, action: PayloadAction<string>) => {
            state.data = action.payload;
        },
        setSchemaOrdering: (state, action: PayloadAction<string>) => {
            state.schemaOrdering = action.payload;
        },
        setModelDataTestValue: (state, action: PayloadAction<number>) => {
            state.testValue = action.payload;
        },
        setAiModelId: (state, action: PayloadAction<string>) => {
            state.aiModelId = action.payload;
        },
        setIsDataCleaning: (state, action: PayloadAction<boolean>) => {
            state.isCleaning = action.payload;
        },
        cleanModelData: (state) => {
            state.data = "";
            state.aiModelId = "";
        },
        setIsProcessing: (state, action: PayloadAction<boolean>) => {
            state.isProcessing = action.payload;
        }
    }
});

export const {
    setIsShowModelDataModal,
    setAiModelId,
    setModelData,
    cleanModelData,
    setModelDataTestValue,
    setSchemaOrdering,
    setIsDataCleaning,
    setIsProcessing
} = statesSlice.actions;

//selectors
export const getIsShowModelDataModal = (store: RootStoreType): boolean => store.modelDataState.modelData.isShowModal;
export const getAiModelId = (store: RootStoreType): string => store.modelDataState.modelData.aiModelId;
export const getModelData = (store: RootStoreType): string => store.modelDataState.modelData.data;
export const getIsProcessing = (store: RootStoreType): boolean => store.modelDataState.modelData.isProcessing;
export const getTestValue = (store: RootStoreType): number => store.modelDataState.modelData.testValue;
export const getSchemaOrdering = (store: RootStoreType): string => store.modelDataState.modelData.schemaOrdering;
export const getIsDataCleaning = (store: RootStoreType): boolean => store.modelDataState.modelData.isCleaning;

export default statesSlice.reducer;